import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { vaccineDispatchConfig } from '../config/vaccineDispatchConfig';

export default function VaccineDispatch() {
  return <CRUDManager config={vaccineDispatchConfig} />;
}